import React, {useState} from 'react'
import './ExpenseFromResp.css'


const ExpenseForm = (props) => {
        const [enteredtitle, setEnteredtitle] = useState("")
        const [enteredamount, setEnteredamount] = useState("")
        const [entereddate, setEntereddate] = useState("")


        // const [userInput, setUserInput] = useState({
        //     enterTititle:"",
        //     enterDate:"",
        //     enterAmount:"",
        // })

        const titleChangeHandler = (e) =>{
            setEnteredtitle(e.target.value)
            // setUserInput(prevState => {
            //     return {...prevState ,enterTititle: e.target.value }
            // })
        }

        const amountChangeHandler = e =>{
            setEnteredamount(e.target.value)
        //     setUserInput(prevState => {
        //     return {...prevState, enterAmount: e.target.value}
        // })
        }

    const dateChangeHandler = e =>{
        setEntereddate(e.target.value)
    //     setUserInput(prevState => {
    //       return {...prevState, enterDate: e.target.value}
    //   })
    }

    const expenseSubmitHandler = e =>{
        e.preventDefault();

        const expenseData = {
            title: enteredtitle,
            amount: enteredamount,
            date: new Date(entereddate),
        }
        props.onSaveExpenseData(expenseData);

        setEnteredtitle("");
        setEnteredamount("");
        setEntereddate("");
    }

    return (
    
    <div className="overall">
      <form onSubmit={expenseSubmitHandler}>
    
        <div className='input-Controls'>
            <div className='input-control'>
            <label htmlFor="expense-name">Expense Name</label> <br />

            <input type="text" 
                name='expenseName'
                id='expense-name' 
                value={enteredtitle}
                required 
                onChange={titleChangeHandler} />
            </div>

            <div className='input-control'>
                <label htmlFor="expense-amount">Expense Amount</label> <br />
                <input 
                type="number" 
                name='expenseAmount' 
                id='expense-amount' 
                value={enteredamount}
                required 
                onChange={amountChangeHandler} />
            </div>

            <div className='input-control'>
                <label htmlFor="expense-date">Expense Date</label> <br />
                <input 
                type="date" 
                name='expenseDate' 
                id='expense-date' 
                min='2019-1-1'
                max='2023-12-31'
                value={entereddate}
                required 
                onChange={dateChangeHandler} />
            </div>
            
        </div>
        <div className="addition">
            <button className='add-expense-btn' type='submit'>Submit</button>
        </div>
        
    </form>
    </div>
    
  )
}


export default ExpenseForm

